<template>
    <div class="el-table-container templateBox">
        <div class="query-form">
            <el-tabs v-model="statusType" @tab-click="handleClick">
                <el-tab-pane v-for="item in pageTypeList" :key="item.name" :label="item.name"
                             :name="item.value"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="query-form">
            <el-button v-if="hasPermission('collection:store:storeRecord:export')"
                       @click="exportData()" size="small">批量导出
            </el-button>
        </div>
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="90px">
            <el-form-item label="入库原因" prop="inWarehouseCause">
                <el-select v-model="searchForm.inWarehouseCause" clearable placeholder="请选择入库原因">
                    <el-option
                        v-for="item in $dictUtils.getDictList('in_warehouse_cause')"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="预入库日期" prop="dataTime">
                <el-date-picker
                        v-model="searchForm.dataTime"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="申请人" prop="applicant">
                <el-select v-model="searchForm.applicant" clearable placeholder="请选择申请人">
                    <el-option
                            v-for="item in applicantList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tips">
            <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
            已选择{{ dataListSelections.length }}项数据
        </div>
        <el-table
                v-if="statusType == 0"
                :data="dataList"
                size="small" height="100%"
                class="table" ref="multipleTable" border
                @selection-change="selectionChangeHandle" row-key='id' v-loading="loading">
            <el-table-column type="selection" :reserve-selection='true' fixed/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="inWarehouseCause" label="入库原因" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("in_warehouse_cause", row.inWarehouseCause, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="inWarehouseTime" label="预入库时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicant" label="申请人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicantTime" label="申请时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="审批状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("collection_status", row.status, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="collectionCount" label="藏品数量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" min-width="150">
                <template slot-scope="{row,$index}">
                    <el-button v-if="hasPermission('collection:store:storeRecord:view')" type="text" size="small"
                               @click="addData('view',row,$index)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-table
            v-else
            :data="collDataList"
            size="small" height="100%"
            class="table" ref="multipleTable" border
            @selection-change="selectionChangeHandle" row-key='id' v-loading="loading">
            <el-table-column type="selection" :reserve-selection='true' fixed/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dataCode" label="藏品编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dataName" label="藏品名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="stockStatus" label="藏品状态" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outWarehouseCause" label="出库原因" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("out_warehouse_cause", row.outWarehouseCause, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="outWarehouseTime" label="出库日期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="delivererBy" label="出库交接人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="receiverBy" label="出库接收人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="preOutWarehouseTime" label="预入库日期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicant" label="申请人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicantTime" label="申请时间" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" min-width="150">
                <template slot-scope="{row,$index}">
                    <el-button v-if="hasPermission('collection:store:storeRecord:view')" type="text" size="small"
                               @click="addData('view',row,$index)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <detail-store ref="detailStore"></detail-store>
        <coll-detail ref="collDetail"></coll-detail>
    </div>
</template>

<script>

import CollDetail from "@/views/modules/collection/store/collDetail.vue";
import DetailStore from "@/views/modules/collection/store/detailStore.vue";

export default {
    name: "outRecord",
    components: {DetailStore, CollDetail},
    data() {
        return {
            statusType: '0',
            searchForm: {
                inWarehouseCause: '',
                applicant: '',
                dataTime: [],
                inWarehouseStartTime: '',
                inWarehouseEndTime: '',
                current: 1,
                size: 20,
            },
            applicantList: [],
            pageTypeList: [
                {
                    name: '入库记录',
                    value: '0',
                },
                {
                    name: '藏品入库台账',
                    value: '1',
                },
            ],

            loading: false,
            dataList: [],
            collDataList: [],
            dataListSelections: [],
            total: 0,
            searchData: {},
            detailCurrt: 0,
        }
    },

    mounted() {
        this.refreshList()
        this.getOthers()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.searchData = JSON.parse(JSON.stringify(this.searchForm))
            if (this.searchData.dataTime && this.searchData.dataTime.length) {
                this.searchData.inWarehouseStartTime = this.searchData.dataTime[0]
                this.searchData.inWarehouseEndTime = this.searchData.dataTime[1]
            } else {
                this.searchData.inWarehouseStartTime = ''
                this.searchData.inWarehouseEndTime = ''
            }
            let fetchUrl
            if (this.statusType == 0) {
                fetchUrl = this.api.collection.inWarehouseInfoQueryPage
                this.$set(this.searchData,'status',2)
            } else {
                fetchUrl = this.api.collection.inWarehouseLedgerQueryPage
            }
            this.$axios(fetchUrl, this.searchData,'post').then(data => {
                if (data && data.status) {
                    if (this.statusType == 0){
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                    }else {
                        this.collDataList = data.data.records
                        if (this.collDataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
            this.$axios(this.api.collection.tabCountInWarehouseInfo).then(data => {
                if (data && data.status) {
                    this.pageTypeList = [
                        {
                            name: '入库记录',
                            value: '0',
                        },
                        {
                            name: '藏品入库台账',
                            value: '1',
                        },
                    ]
                    this.pageTypeList[0].name += '(' + data.data + ')'
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //获取其他信息
        getOthers() {
            this.$axios(this.api.collection.outWarehouseApplyUser).then(data => {
                if (data && data.status) {
                    this.applicantList = data.data
                }
            })
        },

        handleClick() {
            this.refreshList(1, 1)
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },

        // name add新增 view详情 edit编辑
        addData(name, row, index) {
            if (this.statusType == 0){
                this.$refs.detailStore.init(row, 'outRecord')
            }else {
                this.$refs.collDetail.init(row)
            }
        },

        exportData() {
            let ids = this.dataListSelections.map(item => {
                return item.id
            })
            let fetchUrl, name
            if (this.statusType == 0) {
                fetchUrl = this.api.collection.inWarehouseInfoQueryPageExport
                name = '入库记录'
            } else {
                fetchUrl = this.api.collection.inWarehouseLedgerInfoQueryPageExport
                name = '入库台账'
            }
            this.fileBlobDownload(fetchUrl, {
                ...this.searchData,
                ids,
            }, name, 'application/vnd.ms-excel')
        },
    },
}
</script>

<style scoped>
.tips {
    padding: 4px;

    .el-icon-info {
        margin-right: 6px;
    }
}
</style>